var FcMaintenanceTypesOutlinedSelectModule = /** @class */ (function () {
    function FcMaintenanceTypesOutlinedSelectModule() {
    }
    return FcMaintenanceTypesOutlinedSelectModule;
}());
export { FcMaintenanceTypesOutlinedSelectModule };
